/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from 'redux'
import { routerReducer } from 'Store/createStore'
import formikReducers from './formik'
import enhancersReducer from './enhancers'
import internalstore from './internalstore'
import operationsReducer from './operations'
import pblManagementReducer from './pblManagement'
import loadingReducer from './loading'
import userReducer from './user'
import languageReducer from './language'
import changePasswordReducer from './changePassword'
import popupReducer from './popup'
import ttlReducer from './ttl'
// @generator reducers:import

export const makeRootReducer = (asyncReducers) =>
  combineReducers({
    // @generator reducers:combine
    ttl: ttlReducer,
    popup: popupReducer,
    changePassword: changePasswordReducer,
    user: userReducer,
    operations: operationsReducer,
    enhancers: enhancersReducer,
    formik: formikReducers,
    router: routerReducer,
    store: internalstore,
    loading: loadingReducer,
    language: languageReducer,
    pblManagement: pblManagementReducer,
    ...asyncReducers
  })

/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */

export const injectReducer = (store, { key, asyncReducer }) => {
  if (Reflect.has(store.asyncReducers, key)) return

  store.asyncReducers[key] = asyncReducer
  store.replaceReducer(makeRootReducer(store.asyncReducers))
}

export default makeRootReducer
